import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faShareAlt, faPlus, faCheck } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const ListPage = () => {
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState("");
  const [items, setItems] = useState([]);

  const handleAddItem = () => {
    if (inputValue.trim() === "") return;
    const newItems = inputValue
      .split(",") // allow comma separated items
      .map((i) => i.trim())
      .filter((i) => i !== "");
    setItems([...items, ...newItems]);
    setInputValue("");
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      {/* Header */}
      <div className="flex justify-between items-center px-4 py-3 bg-white shadow-sm">
        <div className="flex items-center gap-2">
          <FontAwesomeIcon
            icon={faArrowLeft}
            className="text-gray-700 cursor-pointer"
            onClick={() => navigate(-1)}
          />
          <h1 className="text-md font-semibold text-gray-900">Cart List</h1>
        </div>
        <FontAwesomeIcon icon={faShareAlt} className="text-gray-600 cursor-pointer" />
      </div>

      {/* Input Card */}
      <div className="bg-white rounded-lg shadow-sm mx-3 mt-3 p-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Add Items
        </label>
        <div className="flex items-center border border-gray-300 rounded-md overflow-hidden">
          <input
            type="text"
            placeholder="Enter new item"
            className="flex-1 px-3 py-2 text-sm text-gray-700 focus:outline-none"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleAddItem()}
          />
          <button
            onClick={handleAddItem}
            className="bg-red-500 px-3 py-2 flex items-center justify-center hover:bg-red-600 transition"
          >
            <FontAwesomeIcon icon={faPlus} className="text-white text-sm" />
          </button>
        </div>
        <p className="mt-2 text-xs text-gray-500">
          Write or paste a list. Use a comma (,) or press enter to separate multiple products.
        </p>
      

      {/* Added Items */}
      {items.length > 0 && (
        <div className="mx-3 mt-4 space-y-2">
          {items.map((item, idx) => (
            <div key={idx} className="flex items-center gap-2">
              {/* Red checkbox */}
              <div className="w-5 h-5 flex items-center justify-center bg-red-500 rounded-sm">
                <FontAwesomeIcon icon={faCheck} className="text-white text-xs" />
              </div>
              <span className="text-sm text-gray-700">{item}</span>
            </div>
          ))}
        </div>
      )}
      </div>

      {/* Bottom Bar */}
      <div className="mt-auto bg-white border-t border-gray-300 px-4 py-3 flex justify-between items-center">
        <span
          className={`text-sm font-medium ${
            items.length === 0 ? "text-gray-400" : "text-gray-700"
          }`}
        >
          Save List
        </span>
        <button
          disabled={items.length === 0}
          className={`px-5 py-2 rounded-md text-sm font-medium shadow-sm transition ${
            items.length === 0
              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
              : "bg-red-500 text-white hover:bg-red-600"
          }`}
        >
          Proceed
        </button>
      </div>
    </div>
  );
};

export default ListPage;
